module.exports = "../images/family-package.jpg?v=201a010";